// extracted by mini-css-extract-plugin
export default {"travellers":"p8WyA","travellersTrigger":"NFYql","travellersContainer":"gTzFp","skeleton-progress":"_1l2Ve"};